export default "__VITE_ASSET__0ac456cf__"